import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 65BE2EE5-23A5-49F8-A7A2-AEDD25C9C661
 * name arrow-down-drop-circle-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-drop-circle-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowDownDropCircleOutlineIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M7,10L12,15L17,10H7Z" /></>, 'ArrowDownDropCircleOutlineIcon');
export default ArrowDownDropCircleOutlineIcon